// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"dd206aa3","208":"f3a6352c","419":"05d714b1","439":"d2ec625c","787":"f313a530"}[chunkId] + ".chunk.js";
};